import './list-booking-entries.scss';

import isEmpty from 'lodash/isEmpty';
import { arrayOf, bool, func, number, objectOf, string } from 'prop-types';
import React, { useMemo } from 'react';

import BulkToggleControls from '../../../generic/BulkToggleControls';
import withSelection from '../../../generic/Table/with-selection';
import {
  bookingEntryShape,
  detailedInvoiceShape,
  productShape,
} from '../../../prop-types';
import { groupEntries, isInvoiceStatusReadOnly } from '../../utils';
import BookingEntriesGroup from './BookingEntriesGroup';
import BulkEditBookingEntries from './BulkEditBookingEntries';

function ListBookingEntries(props) {
  const {
    showUpdateButton,
    onAdd,
    onRemove,
    onDelete,
    data,
    budgets,
    products,
    invoice,
    selectedItems,
    allowBulkEdit,
    onToggleSelectionMultiple,
    isEditing,
    ...rest
  } = props;
  const readOnly = invoice && isInvoiceStatusReadOnly(invoice.status);

  const groups = useMemo(
    () => groupEntries(data, products, budgets),
    [data, products, budgets],
  );

  return isEmpty(data) ? (
    <div className="c-balance-line c-invoice-line c-invoice-line__booking-entry-group">
      No booking entries
    </div>
  ) : (
    <>
      {allowBulkEdit && isEditing && (
        <div className="d-flex justify-content-between mb-2">
          <div>
            <BulkToggleControls
              onToggleAll={isSelected => {
                onToggleSelectionMultiple(
                  data.map(item => `select-${item.id}`),
                  isSelected,
                );
              }}
              entities={data}
              activeEntities={selectedItems}
            />
          </div>
          <BulkEditBookingEntries
            selectedEntryIds={selectedItems}
            disabled={selectedItems.length < 1}
          />
        </div>
      )}
      {groups.map(({ label, productId, budget, entries }) => (
        <BookingEntriesGroup
          key={productId}
          title={label}
          entries={entries}
          products={products}
          budget={budget}
          onDelete={readOnly ? undefined : onDelete}
          onAdd={readOnly ? undefined : onAdd}
          onRemove={readOnly ? undefined : onRemove}
          showUpdateButton={readOnly ? false : showUpdateButton}
          invoiceId={invoice && invoice.id}
          showSelectBox={allowBulkEdit}
          onToggleSelectionMultiple={onToggleSelectionMultiple}
          isEditing={isEditing}
          {...rest}
        />
      ))}
    </>
  );
}

ListBookingEntries.propTypes = {
  data: arrayOf(bookingEntryShape.isRequired).isRequired,
  products: arrayOf(productShape.isRequired).isRequired,
  showUpdateButton: bool,
  onDelete: func,
  onAdd: func,
  onRemove: func,
  invoice: detailedInvoiceShape,
  budgets: objectOf(number.isRequired),
  selectedItems: arrayOf(string.isRequired).isRequired,
  onToggleSelectionMultiple: func.isRequired,
  allowBulkEdit: bool,
  isEditing: bool,
};

ListBookingEntries.defaultProps = {
  showUpdateButton: undefined,
  onDelete: undefined,
  onAdd: undefined,
  onRemove: undefined,
  invoice: undefined,
  budgets: {},
  allowBulkEdit: false,
  isEditing: true,
};

export default withSelection({})(ListBookingEntries);
